export const requestConfig = {
  // url: 'https://cloudapi.yixiang.co',
  // devUrl: 'http://172.16.18.74:8081',  // 开发环境后端_子成电脑
  // proUrl: 'http://172.16.18.74:8081',  // 生产环境后端_子成电脑
  devUrl: 'http://mtc.bgrimm.cn:48081',  // 开发环境后端_部署
  proUrl: 'http://mtc.bgrimm.cn:48081',  // 生产环境后端_部署
  // devUrl: 'http://10.81.4.2:8081',  // 开发环境后端_三部服务器
  // proUrl: 'http://10.81.4.2:8081',  // 生产环境后端_三部服务器
  // url: '/proxy',
  timeout: 30000
};



// WEBPACK FOOTER //
// ./src/api/index.js